import { render } from "./SettingsSectionPasswordForm.vue?vue&type=template&id=2df5a20c"
import script from "./SettingsSectionPasswordForm.vue?vue&type=script&lang=js"
export * from "./SettingsSectionPasswordForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__